<template>
    <el-dialog title="APP下载链接" style="text-align:center" :visible="visible" :show="show" width="30%"  @close="close"  :close-on-click-modal="false">
   :close-on-press-escape="false">      <img src="app.png" style="width:300px;height:300px"/>
    </el-dialog>
</template>
<script>
    export default{
        name:'appDownload',
        props:{
            show: {
                type: Boolean,
                default: false
            },
        },
        watch:{
            show(){
                this.visible = this.show;
            },

        },
        methods:{
            close(){
                this.$emit("listenToChildEvent",false);
            }
        }

    }
</script>